import { render, staticRenderFns } from "./AuthorTts.vue?vue&type=template&id=603ee135&"
import script from "./AuthorTts.vue?vue&type=script&lang=js&"
export * from "./AuthorTts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports